import { render, staticRenderFns } from "./QuestionSettingSection.vue?vue&type=template&id=468cc718&"
import script from "./QuestionSettingSection.vue?vue&type=script&lang=js&"
export * from "./QuestionSettingSection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSettingSection.vue?vue&type=style&index=0&id=468cc718&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports